module.exports = __webpack_public_path__ + "ba289ad9915b537d441cc3c8c68d74ac.png";